import axios, { AxiosResponse } from 'axios';
import RoutesIndexes from 'modules/authModule/enums/RoutesIndexes';
import { message } from 'antd';
import moment from 'moment';
import apiUrl from '../../../helpers/apiUrl';

const getFieldNewsRequest = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/field-news`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response: AxiosResponse<{ code: number; message: string }>) => {
      if (response?.data) {
        return response.data;
      }
    });
};

const getFieldNewsCategoriesRequest = async (): Promise<{
  code: number;
  message: string;
  error?: number;
  data?: any;
} | void> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/all-categories`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(
      (
        response:
          | AxiosResponse<{ code: number; message: string }>
          | { data: { code: number; message: string } }
      ) => {
        if (response.data.code === RoutesIndexes.WRONG_USERNAME_OR_PASSWORD) {
          message.error(response.data.message);
        }
        if (response?.data) {
          return response.data;
        }
      }
    )
    .catch((e) => {
      message.error(e.message);
    });
};

export interface getSpecificLexiconRequestTypes {
  data: {
    news: {
      id: number;
      name: string;
      intro: string;
      dateAdd: moment.MomentInput;
      content: string;
      idCategory: number;
      image: string;
    };
    categories: {
      name: string;
      id: number;
    }[];
  };
}

const getSpecificFieldNewsRequest = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/field-news/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const getSpecificFieldNewsCategoryRequest = async (
  id: string
): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/field-news/categories/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const removeSpecificFieldNewsRequest = async (
  idLexicon: number
): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/field-news/${idLexicon}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

const removeSpecificNewsCategoryRequest = async (id: number): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/field-news/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      return true;
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

const createFieldNewsRequest = async (data: {
  id?: number;
  dateAdd: moment.MomentInput;
  name: string;
  intro: string;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/field-news`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      message.success('Pozytywnie utworzono wiadomość terenową');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const createNewsCategoryRequest = async (data: {
  isActive?: boolean;
  name: string;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/field-news`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      message.success('Pozytywnie utworzono kategorię newsa');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const saveFieldNewsRequest = async (data: { id: number }): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/field-news/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const saveNewsCategoryRequest = async (data: { id: number }): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/field-news/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export {
  saveFieldNewsRequest,
  getSpecificFieldNewsRequest,
  getFieldNewsRequest,
  createFieldNewsRequest,
  removeSpecificNewsCategoryRequest,
  createNewsCategoryRequest,
  saveNewsCategoryRequest,
  getFieldNewsCategoriesRequest,
  removeSpecificFieldNewsRequest
};
